// frontend/src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "./Context/AuthContext";
import { SearchProvider } from "./Context/SearchContext";
import { CartProvider } from "./Context/CartContext";

// ── jQuery safety net for legacy scripts ──
import $ from "jquery";
window.$ = window.jQuery = $;
// Attach stubs to the npm‑loaded jQuery
if ($.fn) {
  $.fn.counterUp =
    $.fn.counterUp ||
    function () {
      return this;
    };
  $.fn.sticky =
    $.fn.sticky ||
    function () {
      return this;
    };
  $.fn.owlCarousel =
    $.fn.owlCarousel ||
    function () {
      return this;
    };
}
// ──────────────────────────────────────────────

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <SearchProvider>
          <CartProvider>
            <Router>
              <App />
            </Router>
          </CartProvider>
        </SearchProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
